import Vue from 'vue';
import Vuex from 'vuex';
import { alert } from './modules/alert';
import { app } from './modules/app';
import { bill } from './modules/bill';
import { billItem } from './modules/billItem';
import { contact } from './modules/contact';
import { customer } from './modules/customer';
import { inquiry } from './modules/inquiry';
import { shipment } from './modules/shipment';
import { user } from './modules/user';
import { customerOrganization } from './modules/customerOrganization';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    Alert: alert,
    App: app,
    Bill: bill,
    BillItem: billItem,
    Contact: contact,
    Customer: customer,
    CustomerOrganization: customerOrganization,
    Inquiry: inquiry,
    Shipment: shipment,
    User: user
  }
});
